import { render } from "./InfoPolicy.vue?vue&type=template&id=47b4ff40&ts=true"
import script from "./InfoPolicy.vue?vue&type=script&lang=ts"
export * from "./InfoPolicy.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__